export default {
    excess: 'Önrész',
    security: 'Kaució',
    fuel_policy: 'Üzemanyag-politika',
    like_for_like: 'Azonos az azonossal',
    full_to_full: 'Tele tankkal átvétel, tele tankkal leadás',
    mileage: 'Futásteljesítmény: {mileage} mérföld bérlésenként',
    unlimited_mileage: 'Korlátlan futásteljesítmény',
    non_refundable: 'Nem visszatéríthető',
    free_cancellation_until: 'Ingyenes lemondás eddig: {date}',
    cancellation_with_terms: 'Lemondás {0} a feltételek szerint',
    t_c_text: 'ÁSZF',
    two_free_extras: 'Két ingyenes extra az átvételkor',
    glass_tyres_covered: 'Üveg és gumiabroncs fedezve',
    spec_fuel_petrol: 'benzin',
    spec_fuel_petrol_diesel: 'benzin/dízel',
};
